// Maria, 20 October 2026: the Status filter on the Profiles page uses the words on the profile cards' marks, and each
// option finds the children whose card shows that mark. The values are the backend's ApplicationFilterStatus.
const APPLICANT_STATUSES = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: 3,
        label: 'No Parent Account'
    },
    {
        value: 2,
        label: 'Incomplete Profile'
    },
    {
        value: 1,
        label: 'Profile Complete'
    },
    {
        value: 4,
        label: 'Invitation not Sent'
    }
]

// The values are the backend's StaffProfileStatus. The role labels are those on the staff cards' badges (staffRoles.js).
export const STAFF_STATUSES = [
    {value: 0, label: 'All'},
    {value: 11, label: 'Employee'},
    {value: 12, label: 'Member of Staff'},
    {value: 13, label: 'Senior Staff'},
    {value: 14, label: 'School Admin'},
    {value: 15, label: 'Account not Created'},
    {value: 16, label: 'Invitation not Sent'}
];

export default APPLICANT_STATUSES;
